export default {
    TAB: 9,
    ENTER: 13,
    SPACE : 32,
};
